import React from "react";
import useRyanairHungaryInfoController from "./useRyanairHungaryInfo.controller.js";
import { Icon, Stack, Text } from "@bookingcom/bui-react";
import { InfoSignIcon } from "@bookingcom/bui-assets-react/streamline";
import useProfiler from "../../../../../../../hooks/useProfiler.js";
import { track } from "@flights/et-universal";
const useRyanairHungaryInfo = (flight) => {
    const { header, ryanairHungarytext } = useRyanairHungaryInfoController(flight);
    const { isMobile, isDesktop } = useProfiler();
    if (!ryanairHungarytext)
        return undefined;
    return {
        header,
        content: (isDesktop() && !!track("flights_funnel_new_fd_page_desktop")) ||
            (isMobile() && !!track("flights_funnel_new_fd_page_mobile")) ? (ryanairHungarytext) : (React.createElement(Stack, { direction: "row", gap: 4 },
            React.createElement(Icon, { svg: InfoSignIcon, size: "large" }),
            React.createElement(Stack.Item, { grow: true },
                React.createElement(Text, { variant: "body_2" }, ryanairHungarytext))))
    };
};
export default useRyanairHungaryInfo;
